import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api/knowledge`;

export const knowledgeApi = {
  tree: () => axios.get(`${API}/tree`).then((r) => r.data),
  article: (id) => axios.get(`${API}/articles/${id}`).then((r) => r.data),
  create: (body) => axios.post(`${API}/articles`, body).then((r) => r.data),
  update: (id, body) => axios.put(`${API}/articles/${id}`, body).then((r) => r.data),
  move: (id, body) => axios.patch(`${API}/articles/${id}/move`, body).then((r) => r.data),
  reposition: (id, body) => axios.patch(`${API}/articles/${id}/reposition`, body).then((r) => r.data),
  remove: (id) => axios.delete(`${API}/articles/${id}`).then((r) => r.data),
  search: (q, opts = {}) => axios.get(`${API}/search`, { params: { q, category: opts.category || undefined, tag: opts.tag || undefined } }).then((r) => r.data),
  meta: () => axios.get(`${API}/meta`).then((r) => r.data),
  audienceOptions: () => axios.get(`${API}/audience-options`).then((r) => r.data),
  listComments: (aid) => axios.get(`${API}/articles/${aid}/comments`).then((r) => r.data),
  addComment: (aid, body) => axios.post(`${API}/articles/${aid}/comments`, body).then((r) => r.data),
  replyComment: (cid, text) => axios.post(`${API}/comments/${cid}/reply`, { text }).then((r) => r.data),
  resolveComment: (cid) => axios.post(`${API}/comments/${cid}/resolve`).then((r) => r.data),
  deleteComment: (cid) => axios.delete(`${API}/comments/${cid}`).then((r) => r.data),
  uploadMedia: async (file) => {
    const { lanUpload } = await import('@/lib/lanStorage');
    const legacyUpload = (f) => {
      const fd = new FormData();
      fd.append('file', f);
      return axios.post(`${API}/media`, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      }).then((r) => r.data);
    };
    return lanUpload({
      axios, apiBase: `${BACKEND}/api`, kind: 'knowledge_media',
      file, legacyUpload,
    });
  },
};

// flat list -> nested tree (sorted by order)
export function buildTree(flat) {
  const byParent = new Map();
  flat.forEach((n) => {
    const key = n.parent_id || '__root__';
    if (!byParent.has(key)) byParent.set(key, []);
    byParent.get(key).push(n);
  });
  const build = (key) => (byParent.get(key) || [])
    .sort((a, b) => (a.order - b.order) || String(a.title).localeCompare(String(b.title), 'ja'))
    .map((n) => ({ ...n, children: build(n.id) }));
  return build('__root__');
}
